import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('');
        try {
            const res = await fetch(process.env.REACT_APP_API_URL + 'auth/forgot-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });
            const data = await res.json();
            if (res.ok) {
                setIsError(false);
                setMessage(data.message);
            } else {
                setIsError(true);
                setMessage(data.message);
            }
        } catch (err) {
            setIsError(true);
            setMessage('Something went wrong. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="position-fixed top-0 start-0 w-100 vh-100" style={{ zIndex: 9999, background: "#ffffff" }}>
            <div className="container-fluid h-100">
                <div className="row h-100">
                    <div className="col-md-6 d-flex flex-column justify-content-center align-items-center text-white"
                        style={{ background: "linear-gradient(135deg,#1d3557,#457b9d)" }}>
                        <h1 className="fw-bold mb-3">HashedBit CMS</h1>
                        <p style={{ maxWidth: "360px", textAlign: "center" }}>Reset your admin password securely.</p>
                    </div>
                    <div className="col-md-6 d-flex justify-content-center align-items-center">
                        <div style={{ width: "420px" }}>
                            <h2 className="fw-bold mb-2">Forgot Password</h2>
                            <p className="text-muted mb-4">Enter your email to receive a reset link.</p>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-4">
                                    <label className="form-label fw-semibold">Email Address</label>
                                    <input
                                        type="email"
                                        className="form-control form-control-lg"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                                <button type="submit" className="btn btn-primary w-100 btn-lg shadow" disabled={isLoading}>
                                    {isLoading ? "Sending..." : "Send Reset Link"}
                                </button>
                            </form>
                            {message && (
                                <div className={`alert mt-4 ${isError ? 'alert-danger' : 'alert-success'}`}>
                                    {message}
                                </div>
                            )}
                            <div className="text-center mt-3">
                                <Link to="/login" className="text-primary text-decoration-none small">Back to Login</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
